// @flow
import * as PublicAccountPagesConstant from "../../Constants/PublicAccountPages/publicAccountPagesConstants";

type StateType = {
  formElements: {
    email: string,
    password: string,
    first_name: string,
    last_name: string,
    phone: string,
    address: string,
    city: string,
    district: string,
    country: string,
    postal_code: string
  },
  controlElements: {
    password_verify: string
  },
  status: {
    isPosting: boolean,
    isRegisterSuccessful: boolean,
    hasError: boolean
  }
};

type ActionType = {
  type: string,
  payload: Object
};

const initialState = {
  formElements: {
    email: "",
    password: "",
    first_name: "",
    last_name: "",
    phone: "",
    address: "",
    city: "",
    district: "",
    country: "",
    postal_code: ""
  },
  controlElements: {
    password_verify: ""
  },
  status: {
    isPosting: false,
    isRegisterSuccessful: false,
    hasError: false
  }
}

export default function userregister(state: StateType = initialState, action: ActionType) {
  switch (action.type) {
    case PublicAccountPagesConstant.USER_REGISTER_FORM_ELEMENT_VALUE_CHANGE:
      return userRegisterFormElementValueChange(state, action);
    case PublicAccountPagesConstant.USER_REGISTER_CONTROL_ELEMENT_VALUE_CHANGE:
      return userRegisterControlElementValueChange(state, action);
    case PublicAccountPagesConstant.USER_REGISTER_FORM_SUBMIT_REQUEST:
      return userRegisterFormSubmitRequest(state);
    case PublicAccountPagesConstant.USER_REGISTER_FORM_SUBMIT_SUCCESS:
      return userRegisterFormSubmitSuccess(state);
    case PublicAccountPagesConstant.USER_REGISTER_FORM_SUBMIT_FAILURE:
      return userRegisterFormSubmitFailure(state);
    case PublicAccountPagesConstant.USER_REGISTER_FORM_ERROR_RELEASE:
      return userRegisterFormErrorRelease(state);
    default:
      return state;
  }
}

function userRegisterFormElementValueChange(state, action) {
  const { formElement, value } = action.payload;
  return {
    ...state,
    formElements: {
      ...state.formElements,
      [formElement]: value
    }
  };
}

function userRegisterControlElementValueChange(state, action) {
  const { controlElement, value } = action.payload;
  return {
    ...state,
    controlElements: {
      ...state.controlElements,
      [controlElement]: value
    }
  };
}

function userRegisterFormSubmitRequest(state) {
  return {
    ...state,
    status: {
      isPosting: true,
      isRegisterSuccessful: false,
      hasError: false
    }
  }
}

function userRegisterFormSubmitSuccess(state) {
  return {
    ...state,
    status: {
      isPosting: false,
      isRegisterSuccessful: true,
      hasError: false
    }
  }
}

function userRegisterFormSubmitFailure(state) {
  return {
    ...state,
    status: {
      isPosting: false,
      isRegisterSuccessful: false,
      hasError: true
    }
  }
}

function userRegisterFormErrorRelease(state) {
  return {
    ...state,
    controlElements: {
      password_verify: ""
    },
    status: {
      isPosting: false,
      isRegisterSuccessful: false,
      hasError: false
    }
  };
}



// WEBPACK FOOTER //
// ./src/Reducers/PublicAccountPages/userregister.js